import { TRIGGER_TYPE_LABEL } from "../../../features/builder.constants";
import { parseJsonObject } from "../../../features/builder.utils";
import { resolverOf } from "./recipient-type.utils";

// Mirrors RemRecipientTypeCtl.normalize in the backend (reminder_setup/recipient_type/controller.js).
export const recipientTypeValidation = {
  type_key: (value, formData, dependencies) => {
    const resolver = resolverOf({ type_key: value }, dependencies);
    return !formData.id && resolver?.recipient_type_fid ? "This recipient type is already set up; edit it instead." : "";
  },
  name: (value) => (String(value ?? "").trim().length > 100 ? "Name must be at most 100 characters." : ""),
  allowed_triggers: (value, formData, dependencies) => {
    const allowed = resolverOf(formData, dependencies)?.allowed_triggers ?? [];
    if (!allowed.length) return "";
    const picked = Array.isArray(value) ? value : [];
    return picked.length && picked.every((t) => allowed.includes(t)) ? "" : `This type only works with ${allowed.map((t) => TRIGGER_TYPE_LABEL[t] ?? t).join(", ")} triggers.`;
  },
  sort_order: (value) => {
    if (value === "" || value === null || value === undefined) return "";
    const number = Number(value);
    return Number.isInteger(number) && number >= 0 && number <= 10000 ? "" : "Sort order must be a whole number from 0 to 10000.";
  },
  config_schema_text: (value, formData, dependencies) => {
    if (!formData.edit_schema) return "";
    const schema = parseJsonObject(value ?? "");
    if (schema === undefined) return "Config schema must be a JSON object, or empty.";
    const required = resolverOf(formData, dependencies)?.config_schema?.required ?? [];
    const missing = required.filter((key) => !schema?.properties?.[key]);
    return missing.length ? `Keep ${missing.join(", ")} in the properties (the resolver reads it).` : "";
  },
};
